// @theme component
import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { storageService } from '@core/js/services/storage.service';
import { isStickyGamesBtnShown } from '../constants';

export const useShowAgain = (): [boolean, Dispatch<SetStateAction<boolean>>] => {
    const [isShowAgain, setIsShowAgain] = useState<boolean>(true);

    useEffect(() => {
        const newIsShowAgain = storageService.local.getItem(isStickyGamesBtnShown);
        if (newIsShowAgain === false) {
            setIsShowAgain(newIsShowAgain);
        }
    }, []);

    return [isShowAgain, setIsShowAgain];
};
